import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

interface IProps {
    onClose: () => void;
}

interface IState {}

// 隐私协议
class PrivacyModal extends BaseComponent<IProps, IState> {
    render() {
        const { onClose } = this.props;
        return (
            <div className="privacy-modal">
                <div className="privacy-content">
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="iframe-box">
                        <iframe
                            src={"https://acts.jj.cn/html/activity_topic/static/2210196ece73.html?t=12&type=m_hxz_web"}
                            // src={"https://acts.jj.cn/agreement/agreement_template.html?id=8320C12355F8B3361D23ED889900EFD8BAD44421412477540AA9AD1BDF383FEC"}
                            height={"100%"}
                            width={"100%"}
                            name="iframe-privacy"
                            frameBorder="0"
                            scrolling="no"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default PrivacyModal;
